const BaseModule = require('../../90_utils/base/BaseModule');
const Loader = require('../../90_utils/Loader');

class ContentController extends BaseModule {

	constructor(el, params) {

		super(el);

		this.data = params.data;

		// element vars

		this.pageId;
		this.sectionId;

		this.$contentWrapper = this.$el.find('#primary-content-wrapper');
		this.$currentContent = this.$contentWrapper.find('.primary-content');
		this.$oldContent;

		this.pageLoader;
		this.isLoading = false;
		this.isFirstPage = true;
		this.isPendingAppend = false;
	}

	// basemodule methods

	_domReady(){ }

	_addListeners(){ }

	_removeListeners(){ }

	//

	_onHeroIntroComplete(e, params){ }

	// content changing

	transOutContent(){

		return new Promise((resolve, reject) => {

			if(this.$currentContent && this.$currentContent.length){

				this.$currentContent.find('[data-js-module]').each((index, value) => {
					$(value).triggerHandler('disable');
					resolve();
				});

				if(window.SETTINGS.breakpoint.maxWidth('screen-medium')){
					this.$currentContent.remove();
					this.$currentContent = null;
					window.SETTINGS.animationFrame.one(() => {
						resolve();
					});
				}
			}

		});
	}

	transInContent(){

		return new Promise((resolve, reject) => {

			if(this.$currentContent && this.$currentContent.length){

				// window.vent.on('heroIntroComplete', this._onHeroIntroComplete, this);

				if(this.$oldContent && this.$oldContent.length){

					TweenMax.killTweensOf(this.$oldContent);

					if(this.$el.hasClass('is-scroll-swap')){

						if(window.SETTINGS.breakpoint.minWidth('screen-medium')){

							window.SETTINGS.animationFrame.one(() => {
								this.$oldContent.remove();
								this.$oldContent = null;
								resolve();
							});
						}
						else {

							window.SETTINGS.animationFrame.one(() => {
								this.$oldContent.remove();
								this.$oldContent = null;
								resolve();
							});
						}
					}
					else {

						if(window.SETTINGS.breakpoint.minWidth('screen-medium')){

							this.$oldContent.remove();
							this.$oldContent = null;
							window.SETTINGS.animationFrame.one(() => {
								resolve();
							});

						} else {

							this.$oldContent.remove();
							this.$oldContent = null;
							window.SETTINGS.animationFrame.one(() => {
								resolve();
							});
						}
					}
				}
				else {
					console.log('transInContent - SWAP REJECT - No Old Content');
					resolve();
				}
			}
			else {
				console.log('transInContent - SWAP REJECT - No Current Content');
				resolve();
			}
		});
	}

	swapContentByIndex(index){
		this.swapContentById(this.templates[index].id);
	}

	swapContentById(pageId, sectionId, isScrollSwap){

		console.log('swapContentById', pageId, sectionId, isScrollSwap);

		return new Promise((resolve, reject) => {

			if(pageId !== this.pageId || sectionId !== this.sectionId || this.isFirstPage){

				if(this.isFirstPage){
					this.$currentContent = this.$el.find('.primary-content');
					this.pageId = pageId;
					this.sectionId = sectionId;
					this.isFirstPage = false;
					resolve();
				}
				else {

					let $newContent;
					let pageObj = _.findWhere(window.SETTINGS.templates.content, {id: pageId});

					if(sectionId && sectionId.length){
						let sectionData = _.findWhere(pageObj.sections, {id: sectionId}).template;
						$newContent = $(sectionData);
					}
					else {
						$newContent = $(pageObj.template);
					}

					this.$oldContent = this.$currentContent;
					this.$currentContent = $newContent.hasClass('primary-content') ? $newContent : $(`<div class="primary-content ${pageId}-content ${pageId}-content-${sectionId}"></div>`).append($newContent);
					this.pageId = pageId;
					this.sectionId = sectionId;
					this.isPendingAppend = true;

					let onPageContentLoaded = () => {

						this._appendCurrentContent();
						window.vent.off('pageContentLoaded', onPageContentLoaded, this);

						let resolveDelay = window.SETTINGS.breakpoint.minWidth('screen-medium') ? 2000 : 1000;

						window.setTimeout(() => {
							console.log("content load resolve");
							window.vent.trigger('pageLoadComplete');
							resolve();
						}, resolveDelay);
					}

					window.vent.on('pageContentLoaded', onPageContentLoaded, this);
					this._loadPageContent(this.$currentContent);
				}
			}
			else {
				console.log('SWAP REJECT - Invalid Page Id');
				resolve();
			}
		});
	}

	_appendCurrentContent(){

		if(this.isPendingAppend){

			console.log('_appendCurrentContent');

			this.isPendingAppend = false;

			if(this.$oldContent && this.$oldContent.length){
				this.$oldContent.addClass('old');
			}

			this.$contentWrapper.append(this.$currentContent);

			window.vent.trigger('domUpdate');
		}
	}

	// load page content

	_loadPageContent($content){

		console.log('_loadPageContent', $content);

		let onLoadItemComplete = (e) => {
			window.vent.trigger('pageLoadUpdate', {progress: e.progress});
		}

		let onLoadComplete = (e) => {
			this.isLoading = false;
			window.vent.trigger('pageContentLoaded');
		}

		if(!this.isLoading){

			this.isLoading = true;

			// lock scrolling

			console.log('_loadPageContent - trigger pageLoadStart');
			window.vent.trigger('pageLoadStart');

			// extract urls
			let urls = [];

			if(window.SETTINGS.breakpoint.minWidth('screen-medium') && !window.utils.BrowserUtils.isIE()){

				let $imgs = $content.find('img');
				let $bgImages = $content.find('figure.bg-abs');

				$imgs.each((index, value) => {

					let $img = $(value);
					let url = $img.attr('src');

					if(url && (url.indexOf('.png') >= 0 || url.indexOf('.jpg') >= 0)){
						url = window.utils.BrowserUtils.qualifyURL(url); // convert relative urls to absolute
						if(!_.findWhere(urls, {url:url})){
							urls.push({
								url: url,
								callback:onLoadItemComplete
							});
						}
					}
				});

				$bgImages.each((index, value) => {

					let $figure = $(value);
					let url = $figure.css('background-image');

					if(url && (url.indexOf('.png') >= 0 || url.indexOf('.jpg') >= 0)){
						url = url.slice(4, -1).replace(/["|']/g, ""); // remove url('') wrapper
						url = window.utils.BrowserUtils.qualifyURL(url); // convert relative urls to absolute
						if(!_.findWhere(urls, {url:url})){
							urls.push({
								url: url,
								callback:onLoadItemComplete
							});
						}
					}
				});
			}

			if(this.pageLoader){
				this.pageLoader.emptyQueue();
			}
			else {
				this.pageLoader = new Loader({
					autoStart: false,
					onCompleteCallback: onLoadComplete
				});
			}

			console.log('_loadPageContent - urls', urls);

			if(urls.length){
				this.pageLoader.addToQueue(urls);
				this.pageLoader.start();
			}
			else {
				window.SETTINGS.animationFrame.one(() => {
					onLoadComplete();
				});
			}
		}
	}

	// show / hide

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){ }
}

module.exports = ContentController;
